import MaintenanceMenus from 'src/components/MaintenanceMenus/MaintenanceMenus';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { MenusActionCreator, AppointmentActionCreator, FrameworkActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    menus: state.Menus.allMenus.menus,
    scheduleOptions: state.Menus.allMenus.scheduleOptions,
    selectedScheduleOption: state.Menus.selectedScheduleOption,
    mileageOptions: state.Menus.allMenus.mileageOptions,
    selectedMileageOption: state.Menus.selectedMileageOption,
    defaultScheduleOption: state.Menus.allMenus.defaultScheduleOption,
    defaultMileageOption: state.Menus.allMenus.defaultMileageOption,
    checkedMileageMenu: state.Menus.checkedMileageMenu,
    apptOps: state.Appointment.ApptOps,
    specDefaultDept: state.Specs.specs !== undefined ? state.Specs.specs.departmentFlag : '',
    theme: state.Framework.theme,
    maintContracts: state.AdditionalServices.maintContractData.maintContracts,
    apptVin: state.Appointment.ApptVeh.vin ?? '',
    gmDealerCanEarn: state.Specs.specs?.gmDealerCanEarn,
    vehicles: state.Vehicles.vehicles,
    selectedVehicles: state.Vehicles.selectedVehicle,
    locale: state.Framework.locale,
});

const mapDispatchToProps = {
    setScheduleOption: MenusActionCreator.SetScheduleOption,
    setMileageOption: MenusActionCreator.SetMileageOption,
    getMenus: MenusActionCreator.GetMenus,
    toggleMenu: MenusActionCreator.ToggleMenu,
    UpdateApptOps: AppointmentActionCreator.UpdateApptOps,
    determineDept: AppointmentActionCreator.DetermineDept,
    addLogEntry: FrameworkActionCreator.addLogEntry,
};

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceMenus);